import './Layout.scss';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import NewSidebar from './NewSidebar';
import TopBar from './TopBar';
import HeaderDataFetcher from './HeaderDataFetcher';
import NewsChecker from '../NewsModal/NewsChecker';
import WalletRotationGate from '../WalletRotationGate/WalletRotationGate';

export default function Layout() {
  const theme = useSelector((state) => state.APP_THEME);

  // Sync theme class to document root for portals (modals, tooltips)
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className={`Layout ${theme === 'dark' ? 'dark' : ''}`}>
      <HeaderDataFetcher />
      <WalletRotationGate>
      <NewsChecker />
      <NewSidebar />
      <div className="Layout__main">
        <TopBar />
        <div className="Layout__content">
          <Outlet />
        </div>
      </div>
      </WalletRotationGate>
    </div>
  );
}
